import React, { createContext, useEffect, useState } from 'react';

import { getDataById } from '../helpers/api-helpers';
export const LangContext = createContext();
export const LangProvider = ({ children }) => {
    const [globalPageData, setGlobalPageData] = useState(null);
    useEffect(() => {
        let nodeId = document.querySelector("#root")?.getAttribute("data-node-id");
        if (nodeId) {
            let id = parseInt(nodeId);
            getDataById(id).then(r => setGlobalPageData(r));
        }
    }, []);

    return (
        <LangContext.Provider value={{ globalPageData }}>{children}</LangContext.Provider>
    );
};
